// Small text helpers shared across the Pulso features.

/** Accent-folded, lowercased key for case/diacritic-insensitive search. */
export function searchKey(s: string): string {
  return s
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

/** Escape the HTML-significant characters for safe interpolation into a markup
 * string (e.g. a Leaflet popup, which takes raw HTML). Double-quote is escaped
 * so the result is also safe inside double-quoted attributes. */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"]/g, (c) => {
    switch (c) {
      case "&":
        return "&amp;";
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      default:
        return "&quot;";
    }
  });
}
